import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

type ToastType = 'success' | 'error' | 'warn' | 'info' | 'dark';

export const toaster = (type: ToastType, comment: any) => {
  const fn = toast[type];
  if (typeof fn !== 'function') return;
  return fn(comment, { position: 'top-right', autoClose: 2000 });
};
